import { useState, useRef, useEffect } from "react"
import styles from "./CountrySelector.module.scss"
import { useGetCountriesQuery } from "../../../service/utility-service"
import { CountrySelectorIcon } from "../../../assets/icons"
import { Country } from "../../../model/bill-settings/bill-settings"
import { useConfigLayout } from "../../../hooks/useConfigLayout"

const CountrySelector = () => {
  const { data = [], isLoading, isError, error } = useGetCountriesQuery();
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [containerWidth, setContainerWidth] = useState<number>(0)
  const containerRef = useRef<HTMLDivElement>(null)
  
  const countries = data.length > 0 ? data : [];
  
  const { 
    isCountrySelectorVisible, 
    selectedCountry,
    updateLayout 
  } = useConfigLayout();
  
  const [internalSelectedCountry, setInternalSelectedCountry] = useState<Country | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [])
  
  useEffect(() => {
    if (countries.length > 0 && !internalSelectedCountry) {
      const firstCountry = countries[0];
      setInternalSelectedCountry(firstCountry);
      updateLayout({ country: firstCountry });
    }
  }, [countries, updateLayout, internalSelectedCountry]);
  
  useEffect(() => {
    if (selectedCountry) {
      setInternalSelectedCountry(selectedCountry);
    }
  }, [selectedCountry]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  const handleSetCountry = (country: Country) => {
    setInternalSelectedCountry(country);
    updateLayout({ country });
  }
  
  if (!isCountrySelectorVisible) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div
        className={`${styles.countrySelectorWrapper} ${isCollapsed ? styles.collapsed : ""}`}
        style={{
          width: isCollapsed ? "0" : "240px",
        }}
      >
        <div ref={containerRef} className={styles.countrySelector}>
          <div className={styles.header}>
            <h3 className={styles.title}>Countries</h3>
          </div>

          <div className={styles.countryList}>
            {countries.length > 0 && countries.map((country) => (
              <button
                key={country.id}
                className={`${styles.countryItem} ${internalSelectedCountry?.id === country.id ? styles.selected : ""}`}
                onClick={() => handleSetCountry(country)}
              >
                <img
                  src={country.imageUrl || "/placeholder.svg"}
                  alt={`${country.name} flag`}
                  className={styles.countryFlag}
                />
                <span className={styles.countryName}>{country.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={toggleCollapse}
        className={`${styles.toggleButton} ${isCollapsed ? styles.collapsed : ""}`}
        aria-label={isCollapsed ? "Expand country selector" : "Collapse country selector"}
      >
        <CountrySelectorIcon className={isCollapsed ? styles.rotated : ""} />
      </button>
    </div>
  )
}

export default CountrySelector